<template>
    <div class="container h-100">
        <div class="img">
            <img src="../assets/logo.jpg" alt="" class="d-block img-logo">
        </div>
        <div class="row h-100 align-items-center">
            <div class="col-12 col-md-6 offset-md-3">

                <!-- Show ErrorValidation -->
                <div class="mt-2">
                    <ErrorValidation :errors="validationErrors" v-if="validationErrors"></ErrorValidation>
                </div>

                <div class="card shadow sm">
                    <div class="card-body">
                        <h2 class="text-center">Password</h2>
                        <hr />
                        <form action="javascript:void(0)" method="post">
                            <div class="mb-3">
                                <label for="password" class="form-label">* New Password</label>
                                <input 
                                    type="password" 
                                    v-model="new_password"
                                    name="password" 
                                    id="password"
                                    class="form-control">
                            </div>
                            <div class="mb-3">
                                <label for="password" class="form-label">* Password Confirm</label>
                                <input 
                                    type="password" 
                                    v-model="password_confirm" 
                                    name="password-confirm"
                                    id="password-confirm" 
                                    class="form-control">
                            </div>
                            <button type="submit" :disabled="processing" @click="change()"
                                class="btn btn-primary mb-3 ">
                                {{ processing ? "Please wait" : "Send" }}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import * as authservice from '../services/auth_service'

import ErrorValidation from '../components/ErrorValidation';

export default {
    name:"change-password",
    data(){
        return {           
            email:"",
            new_password:"",
            password_confirm : "",
            validationErrors: '',
            processing : false
        }
    },

    components: {
        ErrorValidation
    },
    
    methods:{  
        
        async change() {
            try {
                this.processing = true;
                const data = {
                    email: this.email,
                    new_password: this.new_password,
                    password_confirm: this.password_confirm,
                    token: this.$route.params.token
                }
                const send = await authservice.changePassword(data);
                const message = send.data.message;
                if (send.data.success) {
                    this.makeToast('Success', message, 'success');
                    this.processing = false;
                    this.clear();
                    setTimeout(() => {
                        this.$router.push('/login')
                    }, 3000);
                }               

            } catch (error) {
                if (error.response.status == 422){
                    this.validationErrors = error.response.data.errors
                    this.processing = false;
                }else{
                    this.makeToast('Error', 'Something went wrong', 'error');
                    this.processing = false;
                }
            }
                
        },

        clear() {
            this.email = "",
            this.new_password = "",
            this.password_confirm = "",
            this.validationErrors = ''
        },
        
        makeToast(title, text, type) {
            this.toastCount++
            this.$bvToast.toast(text, {
                title: title,
                variant: type,
                autoHideDelay: 2000,
                appendToast: true
            })
        },
         
    }
}
</script>
